import ClientSDK from '../../../App/ClientSDK'
import {AxiosResponse} from 'axios'
import {ITarget, IApiPersonRevenue, IPersonRevenue} from './ITarget'
import {Moment} from 'moment'

class Client {
    static getPersonRevenues = (startDate: Moment, endDate: Moment): Promise<IPersonRevenue[]> => {
        const url = `person-revenues/${startDate.format('YYYY-MM-DD')}/${endDate.format('YYYY-MM-DD')}`

        return ClientSDK
            .instance()
            .get(url)
            .then(
                (response: AxiosResponse<IApiPersonRevenue[]>): IPersonRevenue[] => {
                    return response.data.map((personRevenue) => {
                        return {
                            id: personRevenue.id,
                            fullName: personRevenue.first_name
                                ? personRevenue.first_name.concat(' ', personRevenue.last_name)
                                : 'Unknown',
                            amount: personRevenue.amount,
                            date: personRevenue.date,
                            establishmentId: personRevenue.establishment_id,
                            personId: personRevenue.person_id ? personRevenue.person_id : 0
                        }
                    })
                }
            )
    }

    static getPersonTargets = (): Promise<ITarget[]> => {
        const url = `hr/person-targets`

        return ClientSDK
            .instance()
            .get(url)
            .then(
                (response: AxiosResponse<ITarget[]>): ITarget[] => {
                    return response.data.map((apiPersonTarget) => {
                        return {
                            id: apiPersonTarget.id,
                            period: apiPersonTarget.period,
                            amount: apiPersonTarget.amount,
                            persons: apiPersonTarget.persons
                        }
                    })
                }
            )
    }

    static createPersonTarget = (personTarget: ITarget): Promise<ITarget> => {
        const url = `hr/person-targets`

        return ClientSDK
            .instance()
            .post(
                url,
                {
                    period: personTarget.period,
                    amount: personTarget.amount,
                    person_ids: personTarget.persons.map(person => person.id)
                }
            )
            .then((response: AxiosResponse<{ id: string }>) => {
                    if (response.data.id) {
                        personTarget.id = response.data.id

                        return personTarget
                    }
                }
            )
    }

    static deletePersonTarget = (personTarget: ITarget): Promise<ITarget> => {
        const url = `hr/person-targets/${personTarget.id}/delete`

        return ClientSDK
            .instance()
            .delete(url)
            .then(
                (response: AxiosResponse<string>) => {
                    if ('' === response.data) {

                        return personTarget
                    }
                }
            )
    }

    static updatePersonTarget = (oldPersonTarget: ITarget): Promise<ITarget[]> => {
        const url = `hr/person-targets/${oldPersonTarget.id}/update`

        return ClientSDK
            .instance()
            .put(
                url,
                {
                    period: oldPersonTarget.period,
                    amount: oldPersonTarget.amount,
                    person_ids: oldPersonTarget.persons ? oldPersonTarget.persons.map(person => person.id) : []
                }
            )
            .then(
                (response: AxiosResponse<{ id: string }>) => {
                    if (response.data.id) {
                        const newPersonTarget = {...oldPersonTarget}
                        newPersonTarget.id    = response.data.id

                        return [oldPersonTarget, newPersonTarget]
                    }
                }
            )
    }
}

export default Client
